import { Injectable } from '@angular/core';
import { DataService } from './../data.service';
// import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { AuthService } from '../auth.service';
import { catchError, map } from 'rxjs';

@Injectable()
export class CreateMerchantService {
  token;
  token1: any;
  headers: any;
  constructor(private service: AuthService, private dataservice: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid();
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  // createNewMerchant(data) {
  //   return this.service.createMerchant(data);
  // }

  createNewMerchant(data) {
    // this.GetHeaderdetails();
    return this.http.post<any>(environment.createNewMerchantUrl, data);
  }
  saveBusinessAddress(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.saveBusinessAddressUrl, data, { headers: this.headers });
  }
  saveBusinessDetails(data) {

    this.GetHeaderdetails();
    return this.http.post(environment.saveBusinessDetailsUrl, data, { headers: this.headers });
  }
  saveBusinessContactDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveBusinessContactDetailsUrl, data, { headers: this.headers });
  }
  saveCompanyDocuments(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveCompanyDocumentsUrl, data, { headers: this.headers });
  }
  saveBusinessOwnerDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveBusinessOwnerDetailsUrl, data, { headers: this.headers });
  }
  saveOwnerContactDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveOwnerContactDetailsUrl, data, { headers: this.headers });
  }
  saveBankDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveBankDetailsUrl, data, { headers: this.headers });
  }
  saveReferenceDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveReferenceDetailsUrl, data, { headers: this.headers });
  }

  skipAndActiveMerchant(data) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.demoUserActivationUrl, data, { headers: this.headers });
  }

  //uploadfiles 
  GetIfsccodedetails(IfscCode, MerchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.GetHeaderdetails();
    return this.http
      .get<any>(
        environment.GetIfsccodedetails +
        "?IFSCCode=" +
        IfscCode + "&MerchantKeyId=" + MerchantKeyId + "&LoginUserId="+merchantdata.UserId, { headers: this.headers })
        .pipe(map(response => response)
        ,catchError(this.common.handleError));

  }

  verifyadhardetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.verifyadharnum, data, { headers: this.headers });

  }
  verifyadharcarddetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.verifyadharnumber, data, { headers: this.headers });

  }
  SubmitAadharOtp(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post<any>(environment.submitaadharotp, data, { headers: this.headers });

  }

  GetProfile() {
    this.GetHeaderdetails();
    var userId = this.common.getUserId();
    var email = this.common.getEmail();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.ProfileUrl + '?userId=' + userId +
      "&email=" + email+"&merchantKeyId=" + merchantdata.MerchantKeyId+"&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
  }

  saveMerchantonboardBusinessDetails(data) {
    return this.http.post(environment.saveMerchantonboardBusinessDetailsurl, data, { headers: this.headers });
  }
  saveonboardCompanyDocuments(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveonboardCompanyDocuments, data, { headers: this.headers });
  }
  savelookingdetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.savelookingdetails, data, { headers: this.headers });
  }
  saveOnboardOwnerContactDetailsUrl(data) {

    this.GetHeaderdetails();
    return this.http.post(environment.saveOnboardOwnerContactDetailsUrl, data, { headers: this.headers });
  }
  saveOnboardReferenceDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.saveOnboardReferenceDetailsUrl, data, { headers: this.headers });
  }
  saveOnboardBankDetails(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.saveOnboardBankDetailsurl, data, { headers: this.headers });
  }

  saveonboardbusinessdetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.saveonboardbusinessdetailUrl, data, { headers: this.headers });
  }


  saveAadhardetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.savesaveAadhardetailUrl, data, { headers: this.headers });
  }


  saveonboardOwnerDetails(data) {
    this.GetHeaderdetails();
    return this.http.post(environment.SaveOnboardBusinessOwnerDetailsUrl, data, { headers: this.headers });
  }


  saveonoardingTable(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.saveonoardingTable, data, { headers: this.headers });
  }

  saveKycverificationTable(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.savekycverificationtable, data, { headers: this.headers });
  }

  VerifyingBankdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.VerifyingBankdetails, data, { headers: this.headers });
  }

  CheckFundBankTransfer(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.CheckFundBankTransferdetails, data, { headers: this.headers });
  }


  UpdateBankdetailsstatus(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.UpdateBankdetailsstatus, data, { headers: this.headers });
  }

  ApproveAadhar(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
    return this.http.post(environment.ApproveAadhar, data, { headers: this.headers });
  }
  getBoardingKycDatas(merchantkeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantKycDataUrl + "?merchantkeyId=" + merchantkeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response)
      ,catchError(this.common.handleError));
  }

  Zipcodedetails(Zipcode, Merchantkeyid) {
    this.GetHeaderdetails();
    return this.http.get<any>(environment.Zipcodedetailsurl + "?Zipcode=" + Zipcode + "&Merchantkeyid=" + Merchantkeyid, { headers: this.headers })
      .pipe(map(response => response)
      ,catchError(this.common.handleError));
  }
  ValidateBankdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.ValidateBankdetails, data, { headers: this.headers });
  }
  savebankaccountdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.savebankaccountdetails, data, { headers: this.headers });
  }
  updatebankaccountdetails(data) {
    this.GetHeaderdetails();
    let loggedUsername = this.common.getUserName()
    this.token1 = data.MerchantKeyId + ":" + environment.GetAuthenticationTokenpaymentApp + ":" + 'IT' + ":" + data.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token1));
    return this.http.post<any>(environment.Updatebankacctdetailsurl, data, { headers: this.headers });
  }



  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
  GetBankList(MerchantKeyid) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http
      .get<any>(
        environment.GetBankList +
        "?&MerchantKeyId=" + MerchantKeyid+ "&LoginUserId="+merchantdata.UserId
        , { headers: this.headers });
        // .map(response => response).catch(this.common.handleError);

  }
}
